import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '../../../components/Avatar';
import { ListItemText, Menu, MenuItem } from '../../../components';
import IconButton from '../../../components/IconButton';
import { pagesText } from '../../../constants/pagesText';
import useLogutUser from './useLogutUser';
import useQueryData from '../../../queries/useQueryData';
import { CUSTOMER_QUERY_KEY, USER_QUERY_KEY } from '../../../constants/query';
import { userFirstNameSelector, userLastNameSelector } from '../../../selectors/user';
import { PORTAL_ROUTE } from '../../../constants/routes';
import { companyNameSelector } from '../../../selectors/customer';
import CustomerIdService from '../../../services/customer-id.service';

const AccountMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { logout } = useLogutUser();
  const navigate = useNavigate();
  const userFirstName = useQueryData(USER_QUERY_KEY, userFirstNameSelector);
  const userLastName = useQueryData(USER_QUERY_KEY, userLastNameSelector);
  const companyName = useQueryData(CUSTOMER_QUERY_KEY, companyNameSelector);

  const onLogoutClick = () => {
    logout();
    CustomerIdService.removeId();
  };

  const onMenuOpen = useCallback(
    event => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl],
  );

  const onClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  const onSettingsClick = useCallback(() => {
    navigate(`${PORTAL_ROUTE}/profile/general`);
  }, [navigate]);

  const onChangeOrganization = useCallback(() => {
    navigate(`${PORTAL_ROUTE}/company/environments`);
  }, [navigate]);

  return (
    <>
      {!!userFirstName && !!userLastName && (
        <IconButton onClick={onMenuOpen} color="#B5B5B5">
          <Avatar firstName={userFirstName} lastName={userLastName} src="/" />
        </IconButton>
      )}
      <Menu anchorEl={anchorEl} onClose={onClose}>
        <MenuItem onClick={onSettingsClick} disableRipple styles={{ maxWidth: '224px' }}>
          {!!userFirstName && !!userLastName && (
            <ListItemAvatar>
              <Avatar firstName={userFirstName} lastName={userLastName} src="/" />
            </ListItemAvatar>
          )}
          <ListItemText
            primary={`${userFirstName} ${userLastName}`}
            secondary={companyName}
            primaryStyles={{
              fontSize: 16,
              lineHeight: '24px',
              fontWeight: 400,
              color: '#fff',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
            secondaryStyles={{
              fontSize: 12,
              lineHeight: '20px',
              fontWeight: 400,
              color: '#DDDDDD',
              overflowWrap: 'break-word',
              whiteSpace: 'pre-wrap',
            }}
          />
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={onSettingsClick}
          icon="solar:settings-bold"
          text={pagesText.userProfileMenu.settings}
        />
        <MenuItem
          onClick={onChangeOrganization}
          icon="clarity:two-way-arrows-line"
          text={pagesText.userProfileMenu.changeOrganization}
        />
        <Divider />
        <MenuItem
          onClick={onLogoutClick}
          icon="uil:arrow-from-right"
          text={pagesText.userProfileMenu.logout}
        />
      </Menu>
    </>
  );
};

export default AccountMenu;
